export { NewsletterTabs, NewsletterHubEditorStep, NewsletterSentPreviewTabs, ResendType };
export type { Template };

enum NewsletterTabs {
  sent = 1,
  scheduled,
  draft,
  archived,
}

enum ResendType {
  /**
   * This is when `resend` is `false`
   */
  NONE = 0,
  /**
   * OPCA
   */
  OPENED = 1,
  /**
   * NOCA
   */
  NOT_OPENED = 2,
}

enum NewsletterSentPreviewTabs {
  details = "details",
  preview = "preview",
  audience = "audience",
  links = "popularLinks",
  rejected = "localRejected",
}

type Template = {
  categoryId: number;
  id: number;
  html: string;
  imageUrl: string;
  lang: string;
  title: string;
  unlayerConfig: string;
  type: "custom" | "edrone";
};

enum NewsletterHubEditorStep {
  template,
  design,
  settings,
  audience,
  schedule,
}
